export default "__VITE_ASSET__BTxMih0z__"